var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9127 3.96251C28.6352 3.72742 28.2993 3.57189 27.9405 3.51247C27.5818 3.45304 27.2136 3.49193 26.8752 3.62501L3.80017 12.6875C3.39544 12.8417 3.05261 13.1247 2.82449 13.4928C2.59636 13.861 2.49558 14.2939 2.53767 14.725C2.57522 15.1559 2.75144 15.563 3.03991 15.8853C3.32838 16.2076 3.71355 16.4276 4.13767 16.5125L10.0002 17.675V25C9.99996 25.3963 10.1175 25.7837 10.3378 26.1131C10.5581 26.4424 10.8713 26.6989 11.2377 26.85C11.4801 26.9476 11.7388 26.9985 12.0002 27C12.2628 27.0009 12.5231 26.9495 12.7656 26.8486C13.0082 26.7477 13.2281 26.5994 13.4127 26.4125L16.6627 23.175L21.5752 27.5C21.9378 27.8199 22.4041 27.9975 22.8877 28C23.1003 28.0044 23.312 27.9705 23.5127 27.9C23.8425 27.7956 24.1394 27.607 24.374 27.3527C24.6086 27.0983 24.7727 26.7872 24.8502 26.45L29.5502 5.92501C29.6323 5.57084 29.6164 5.20098 29.5041 4.8552C29.3917 4.50941 29.1873 4.20079 28.9127 3.96251V3.96251ZM22.9002 26L12.6002 16.9375L27.4377 6.22501L22.9002 26Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ff47b84da61c5a1cf5e19a386d2480c4.svg";
export { ForwardRef as ReactComponent };